import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-white px-4 py-5 sm:px-6" aria-labelledby="guarantee-heading" data-id="element-77" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-xl rounded-xl border-2 border-brand-green bg-brand-cream p-3.5 text-center" data-id="element-78" data-mp="22368xudz85ss">
        <ShieldCheckIcon className="mx-auto mb-1 h-8 w-8 text-brand-green" aria-hidden="true" data-id="element-79" data-mp="1x3tp7iiejeuf" />
        <h2 id="guarantee-heading" className="mb-0.5 font-heading text-lg uppercase leading-tight text-brand-navy sm:text-2xl" data-id="element-80" data-mp="19fismrjqo1by">
          Votre achat est entièrement protégé
        </h2>
        <p className="mb-1 text-[12px] font-extrabold uppercase text-brand-green sm:text-sm" data-id="element-81" data-mp="1j650u0p4lpkm">
          🛡️ Garantie satisfait ou remboursé pendant 7 jours
        </p>
        <p className="text-[11px] font-medium leading-snug text-brand-ink/80 sm:text-xs" data-id="element-82" data-mp="qnhkszozl0qe">
          Essayez PADEL COACH READY™ pendant 7 jours. Découvrez les 6 modules, les 5 Bonus Premium et
          commencez immédiatement à utiliser toutes les ressources avec vos joueurs. Si vous n&apos;êtes
          pas entièrement satisfait, contactez-nous dans les 7 jours suivant votre achat et nous vous
          rembourserons 100 % de votre commande.
        </p>
        <p className="mt-1 text-[11px] font-extrabold uppercase text-brand-navy sm:text-xs" data-id="element-83" data-mp="yrp49vxzjw5e">
          Aucun risque. Aucune justification.
        </p>
      </div>
    </section>;
}